import { Injectable } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { GasNetworkTariffModel } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class OrderTimeService {

  constructor(private i18n: I18n) {}

  getStringOrderTime(type: GasNetworkTariffModel.TypeEnum, hours: number): string {
    if (hours >= 24) {
      const d = Math.floor(hours / 24);
      const h = hours % 24;

      return `${this.getDailyOrderTime(d)} ${h ? this.getHoursOrderTime(h) : ''}`;
    } else {
      return this.getHoursOrderTime(hours);
    }
  }

  private getDailyOrderTime(days: number): string {
    return this.i18n('{{days}} дней', { days });
  }

  private getHoursOrderTime(hours: number): string {
    return this.i18n('{{hours}} часов', { hours });
  }
}
